import { Client } from "../client";
import { CreateSessionOptions, CreateSessionResponse } from "../interfaces";
import { preciseRound } from "../utils";

export class Session {
  private client: Client;
  private network: string;
  private config: object;

  constructor(client: Client, network: string, config: object) {
    this.client = client;
    this.network = network;
    this.config = config;
  }

  /**
   * It takes in an object, makes a POST request to the /session endpoint, and returns
   * the response data
   * @param {CreateSessionOptions} options - SessionOptions
   * @returns The response data from the API call.
   */
  async create(options: CreateSessionOptions): Promise<CreateSessionResponse> {
    try {
      let amount = preciseRound(
        options.items.reduce(
          (index, { price, quantity }) => index + price * quantity,
          0
        ),
        3
      );

      if (options.shipping_fees) {
        amount = preciseRound(amount + options.shipping_fees, 3);
      }

      const parameters = {
        ...options,
        network: this.network,
        amount,
        config: this.config,
      };

      const response = await this.client.post(`/session`, parameters);
      return response.data;
    } catch (err) {
      throw new Error(err);
    }
  }
}
